import {
  collection,
  addDoc,
  serverTimestamp
} from 'firebase/firestore';
import { db } from './config';

const COLLECTION = 'websiteContacts';

export const contactService = {
  async createContact(formData) {
    const contactData = {
      name: formData.name,
      email: formData.email.toLowerCase(),
      phone: formData.phone || '',
      subject: formData.subject,
      message: formData.message,
      status: 'new',
      source: 'website_contact_form',
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      respondedAt: null,
      respondedBy: null
    };

    const docRef = await addDoc(collection(db, COLLECTION), contactData);

    // Log to security logs for monitoring
    try {
      await addDoc(collection(db, 'securityLogs'), {
        action: 'create',
        collection: 'websiteContacts',
        documentId: docRef.id,
        userId: null,
        userEmail: formData.email.toLowerCase(),
        before: null,
        after: {
          subject: formData.subject,
          status: 'new',
          source: 'website_contact_form'
        },
        changedFields: null,
        recaptchaScore: null,
        ip: null,
        userAgent: navigator.userAgent,
        timestamp: serverTimestamp()
      });
    } catch (err) {
      console.error('Error logging to securityLogs:', err);
    }

    return {
      contact: { id: docRef.id, ...contactData }
    };
  }
};

export default contactService;
